module.exports = __webpack_public_path__ + "media/images/banners/slide-3-2fa317afa671c77d4662564b1c595c3d.jpg";